module.exports = __webpack_public_path__ + "static/media/film-production-grid-6.442b9989.jpg";